import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  ApiResponse,
  Category,
  CreateCategoryRequest,
  GetCategoriesParams,
  UpdateCategoryRequest,
} from "@/types/categoryTypes";

const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;

export const categoryApi = createApi({
  reducerPath: "categoryApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: "include",
    // prepareHeaders: (headers) => {
    //   const token = localStorage.getItem("accessToken");
    //   if (token) {
    //     headers.set("authorization", `Bearer ${token}`);
    //   }
    //   return headers;
    // },
  }),
  tagTypes: ["Category"],
  endpoints: (builder) => ({
    createCategory: builder.mutation<
      ApiResponse<Category>,
      CreateCategoryRequest
    >({
      query: (data) => ({
        url: "/category/create-category",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Category"],
    }),
    getAllCategories: builder.query<
      ApiResponse<Category[]>,
      GetCategoriesParams | void
    >({
      query: (params) => ({
        url: "/category",
        params: params || undefined,
      }),
      providesTags: ["Category"],
    }),
    getCategoryById: builder.query<ApiResponse<Category>, string>({
      query: (id) => `/category/${id}`,
      providesTags: ["Category"],
    }),
    updateCategory: builder.mutation<
      ApiResponse<Category>,
      UpdateCategoryRequest
    >({
      query: ({ id, data }) => ({
        url: `/category/edit-category/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Category"],
    }),
    deleteCategory: builder.mutation<ApiResponse, string>({
      query: (id) => ({
        url: `/category/delete-category/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Category"],
    }),
  }),
});

export const {
  useCreateCategoryMutation,
  useGetAllCategoriesQuery,
  useGetCategoryByIdQuery,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
} = categoryApi;
